import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-custom-help-info-tooltip',
  standalone: true,
  imports: [SvgIconComponent],
  templateUrl: './custom-help-info-tooltip.component.html',
  styleUrl: './custom-help-info-tooltip.component.scss',
})
export class CustomHelpInfoTooltipComponent {
  @Output() tooltipCloseClicked = new EventEmitter<boolean>();
  @Input() tooltipText!: string;
  @Input() tooltipWidth!: string;
  @Input() tooltipDirection!: string;

  public tooltipDismiss(): void {
    this.tooltipCloseClicked.emit(true);
  }
}
